// /* eslint-disable */
// import React from "react";
// import {
//     Chart as ChartJS,
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     PointElement,
//     LineElement,
//     Tooltip,
//     Legend,
// } from "chart.js";
// import { Bar } from "react-chartjs-2";

// ChartJS.register(
//     CategoryScale,
//     LinearScale,
//     BarElement,
//     PointElement,
//     LineElement,
//     Tooltip,
//     Legend
// );

// const OverallTransitionSummaryCharts = ({ data }) => {
//     const labels = [
//         "Go-live Completed",
//         "Transition in Progress",
//         "Inflight",
//         "WIP",
//     ];

//     const chartData = {
//         labels,
//         datasets: [
//             {
//                 label: "Q1",
//                 data: data.Q1,
//                 backgroundColor: "#7CB342",
//             },
//             {
//                 label: "Q2",
//                 data: data.Q2,
//                 backgroundColor: "#AED581",
//             },
//             {
//                 label: "Q3",
//                 data: data.Q3,
//                 backgroundColor: "#C5E1A5",
//             },
//             {
//                 label: "Q4",
//                 data: data.Q4,
//                 backgroundColor: "#FBC02D",
//             },
//             {
//                 label: "Overall",
//                 data: data.Overall,
//                 type: "line",
//                 borderColor: "#1976D2",
//                 backgroundColor: "#1976D2",
//                 tension: 0.3,
//                 pointRadius: 5,
//                 yAxisID: "y",
//             },
//         ],
//     };

//     const options = {
//         responsive: true,
//         plugins: {
//             legend: {
//                 position: "top",
//                 labels: {
//                     usePointStyle: true,
//                     pointStyle: "circle",
//                     boxWidth: 8,
//                     boxHeight: 8,
//                     padding: 14,
//                     font: {
//                         size: 12,
//                     },
//                 },
//             },
//             title: {
//                 display: false,
//                 text: "Overall Transition Summary",
//                 font: { size: 16 },
//             },
//         },
//         scales: {
//             y: {
//                 title: {
//                     display: true,
//                     text: "FTE Counts",
//                 },
//                 beginAtZero: true,
//             },
//         },
//     };

//     const thStyle = {
//         border: "1px solid #ddd",
//         padding: "4px",
//         textAlign: "center",
//         width: "100px",
//         fontWeight: "600",
//         background: "#f5f5f5",
//     };

//     const tdLabelStyle = {
//         border: "1px solid #ddd",
//         padding: "4px",
//         width: "120px",
//     };

//     const tdValueStyle = {
//         border: "1px solid #ddd",
//         padding: "4px",
//         textAlign: "center",
//         width: "160px",
//     };


//     return (
//         <div style={{ width: "100%", background: "#fff", padding: "16px" }}>
//             {/* Chart */}
//             <Bar data={chartData} options={options} />

//             {/* <div style={{ marginTop: "16px", overflowX: "auto" }}>
//                 <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                     <thead>
//                         <tr>
//                             <th></th>
//                             {labels.map((l) => (
//                                 <th key={l}>{l}</th>
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {["Q1", "Q2", "Q3", "Q4", "Overall"].map((key) => (
//                             <tr key={key}>
//                                 <td><b>{key}</b></td>
//                                 {data[key].map((v, i) => (
//                                     <td key={i} style={{ textAlign: "center" }}>{v}</td>
//                                 ))}
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div> */}
//             <div style={{ marginTop: "16px", overflowX: "auto" }}>
//                 <table
//                     style={{
//                         width: "100%",
//                         borderCollapse: "collapse",
//                         // tableLayout: "fixed",
//                         fontSize: "12px",
//                     }}
//                 >
//                     <thead>
//                         <tr>
//                             <th style={thStyle}></th>
//                             {labels.map((l) => (
//                                 <th key={l} style={thStyle}>{l}</th>
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {["Q1", "Q2", "Q3", "Q4", "Overall"].map((key) => (
//                             <tr key={key}>
//                                 <td style={tdLabelStyle}><b>{key}</b></td>
//                                 {data[key].map((v, i) => (
//                                     <td key={i} style={tdValueStyle}>{v}</td>
//                                 ))}
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };

// export default OverallTransitionSummaryCharts;

// ################# New code ###################

/* eslint-disable */
import React from "react";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { color } from "echarts";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    ChartDataLabels
);

// const OverallTransitionSummaryCharts = ({ labels, chartData }) => {

//     const maxValue = Math.max(
//         ...chartData.datasets.flatMap(ds => ds.data),
//         0
//     );

//     const options = {
//         responsive: true,
//         plugins: {
//             legend: {
//                 position: "top",
//                 labels: {
//                     usePointStyle: true,
//                     pointStyle: "circle",
//                     boxWidth: 12,
//                     boxHeight: 12,
//                     padding: 14,
//                     font: { size: 12 },
//                 },
//             },
//             datalabels: {
//                 display: true,
//                 color: "#000",
//                 anchor: "end",
//                 align: "top",
//                 offset: 4,
//                 font: {
//                     size: 11,
//                     weight: "bold",
//                 },
//                 formatter: (value) => (value > 0 ? value : ""),
//             },
//         },
//         scales: {
//             y: {
//                 title: {
//                     display: true,
//                     text: "FTE Counts",
//                 },
//                 beginAtZero: true,
//                 max: maxValue + 40,
//                 ticks: {
//                     stepSize: 40,
//                 },
//             },
//         },
//     };


//     const thStyle = {
//         border: "1px solid #d2d2d2ff",
//         padding: "4px",
//         textAlign: "center",
//         width: "100px",
//         fontWeight: "bold",
//         color:"#272323ff",
//         background: "#f5f5f5",
//     };

//     const tdLabelStyle = {
//         border: "1px solid #ddd",
//         padding: "4px",
//         textAlign: "center",
//         width: "90px",
//     };

//     const tdValueStyle = {
//         border: "1px solid #ddd",
//         padding: "4px",
//         textAlign: "center",
//         width: "170px",
//     };

//     return (
//         <div style={{ width: "100%", background: "#fff", padding: "16px" }}>
//             <Bar data={chartData} options={options} />
//             <div style={{ marginTop: "16px", overflowX: "auto" }}>
//                 <table
//                     style={{
//                         width: "100%",
//                         borderCollapse: "collapse",
//                         fontSize: "11px",
//                     }}
//                 >
//                     <thead>
//                         <tr>
//                             <th style={thStyle}></th>
//                             {labels.map((l) => (
//                                 <th key={l} style={thStyle}>{l}</th>
//                             ))}
//                         </tr>
//                     </thead>

//                     <tbody>
//                         {chartData.datasets.map((ds) => (
//                             <tr key={ds.label}>
//                                 <td style={tdLabelStyle}><b>{ds.label}</b></td>
//                                 {ds.data.map((v, i) => (
//                                     <td key={i} style={tdValueStyle}>{v}</td>
//                                 ))}
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };

//04-2026

// const OverallTransitionSummaryCharts = ({ labels, chartData }) => {

//     const maxValue = Math.max(
//         ...chartData.datasets.flatMap(ds => ds.data),
//         0
//     );

//     const enhancedChartData = {
//         ...chartData,
//         datasets: chartData.datasets.map((ds, index) => {
//             const isLine =
//                 ds.type === "line" ||
//                 ds.label?.toLowerCase().includes("net") ||
//                 ds.label?.toLowerCase().includes("trend");

//             if (isLine) {
//                 return {
//                     ...ds,
//                     type: "line",
//                     tension: 0.3,
//                     pointRadius: 4,
//                     pointHoverRadius: 5,
//                 };
//             }

//             // ✅ FORCE BAR DATASETS
//             return {
//                 ...ds,
//                 type: "bar",

//                 // 🔥 BAR SIZE & SPACING
//                 barPercentage: 0.6,
//                 categoryPercentage: 0.75,
//                 minBarLength: 18,
//                 // borderRadius: 6,
//             };
//         }),
//     };


//     // const options = {
//     //     responsive: true,
//     //     plugins: {
//     //         legend: {
//     //             position: "top",
//     //             labels: {
//     //                 usePointStyle: true,
//     //                 pointStyle: "circle",
//     //                 boxWidth: 12,
//     //                 boxHeight: 12,
//     //                 padding: 14,
//     //                 font: { size: 12 },
//     //             },
//     //         },
//     //         datalabels: {
//     //             display: true,
//     //             color: "#000",
//     //             // anchor: "end",
//     //             align: "top",
//     //             offset: (context) => {
//     //                 const isLine = context.chart.config.type === 'line';
//     //                 const datasetIndex = context.datasetIndex;
//     //                 const baseOffset = isLine ? 5 : 4;
//     //                 return baseOffset + (datasetIndex * 15);
//     //             },
//     //             font: {
//     //                 size: 10,
//     //                 weight: "bold",
//     //             },
//     //             formatter: (value) => (value > 0 ? value : ""),
//     //         },
//     //     },
//     //     scales: {
//     //         y: {
//     //             title: {
//     //                 display: true,
//     //                 text: "FTE Counts",
//     //             },
//     //             beginAtZero: true,
//     //             max: maxValue + (maxValue * 0.15 + 120),
//     //             ticks: {
//     //                 stepSize: 40,
//     //             },
//     //         },
//     //     },
//     // };

//     // const options = {
//     //     responsive: true,
//     //     layout: {
//     //         padding: {
//     //             top: 30,
//     //             bottom: 20,
//     //         },
//     //     },
//     //     plugins: {
//     //         legend: {
//     //             position: "top",
//     //             labels: {
//     //                 usePointStyle: true,
//     //                 pointStyle: "circle",
//     //                 boxWidth: 12,
//     //                 boxHeight: 12,
//     //                 padding: 20,   // 🔹 extra space between legend items
//     //                 font: { size: 12 },
//     //             },
//     //         },
//     //         datalabels: {
//     //             display: true,
//     //             color: "#000",

//     //             anchor: "end",
//     //             align: "top",

//     //             offset: (context) => {
//     //                 const { datasetIndex } = context;

//     //                 // 🔹 ASSUMPTION: line datasets come after bar datasets
//     //                 const isLineDataset = datasetIndex >= context.chart.data.datasets
//     //                     .filter(ds => ds.type !== "line").length;

//     //                 // Base spacing
//     //                 let offset = isLineDataset ? 2 : 8;

//     //                 // 🔥 Ensure separation between multiple datasets
//     //                 offset += datasetIndex * 10;

//     //                 return offset;
//     //             },

//     //             font: {
//     //                 size: 10,
//     //                 weight: "bold",
//     //             },
//     //             formatter: (value) => (value > 0 ? value : ""),
//     //         }


//     //     },
//     //     scales: {
//     //         x: {
//     //             ticks: {
//     //                 padding: 10,   // 🔹 space between x-axis labels & chart
//     //             },
//     //         },
//     //         y: {
//     //             title: {
//     //                 display: true,
//     //                 text: "FTE Counts",
//     //                 padding: { bottom: 10 },
//     //             },
//     //             beginAtZero: true,
//     //             max: maxValue + (maxValue * 0.15 + 250),
//     //             ticks: {
//     //                 stepSize: 10,
//     //                 padding: 30,   // 🔹 space between y-axis ticks
//     //             },
//     //         },
//     //     },
//     // };


//     const options = {
//         responsive: true,
//         layout: {
//             padding: {
//                 top: 30,
//                 bottom: 20,
//             },
//         },
//         plugins: {
//             legend: {
//                 position: "top",
//                 labels: {
//                     usePointStyle: true,
//                     pointStyle: "circle",
//                     boxWidth: 12,
//                     boxHeight: 12,
//                     padding: 20,
//                     font: { size: 12 },
//                 },
//             },

//             datalabels: {
//                 display: true,

//                 formatter: (value) => (value > 0 ? value : ""),

//                 color: (context) =>
//                     context.dataset.type === "line" ? "#000" : "#000",

//                 anchor: (context) =>
//                     context.dataset.type === "line" ? "end" : "center",

//                 align: (context) =>
//                     context.dataset.type === "line"
//                         ? "top"
//                         : context.raw <= 10
//                             ? "end"
//                             : "center",

//                 offset: (context) => {
//                     const { dataset, raw } = context;

//                     // Line labels → clearly above
//                     if (dataset.type === "line") {
//                         return 14;
//                     }

//                     // Small bar values → pull label up slightly
//                     if (raw <= 10) {
//                         return -6;
//                     }

//                     // Normal bar values
//                     return 0;
//                 },

//                 font: {
//                     size: 11,
//                     weight: "bold",
//                 },
//             },
//         },

//         scales: {
//             x: {
//                 ticks: {
//                     padding: 10,
//                 },
//             },
//             y: {
//                 beginAtZero: true,
//                 suggestedMax: maxValue + 50,
//                 ticks: {
//                     stepSize:
//                         maxValue <= 50 ? 5 :
//                             maxValue <= 100 ? 10 :
//                                 maxValue <= 500 ? 50 :
//                                     100,
//                     padding: 20,
//                 },
//             },

//         },
//     };


//     const thStyle = {
//         border: "1px solid #d2d2d2ff",
//         padding: "4px",
//         textAlign: "center",
//         width: "100px",
//         fontWeight: "bold",
//         color: "#272323ff",
//         background: "#f5f5f5",
//     };

//     const tdLabelStyle = {
//         border: "1px solid #ddd",
//         padding: "4px",
//         textAlign: "center",
//         width: "90px",
//     };

//     const tdValueStyle = {
//         border: "1px solid #ddd",
//         padding: "4px",
//         textAlign: "center",
//         width: "170px",
//     };

//     return (
//         <div style={{ width: "100%", background: "#fff", padding: "16px" }}>
//             <Bar data={enhancedChartData} options={options} />
//             <div style={{ marginTop: "16px", overflowX: "auto" }}>
//                 <table
//                     style={{
//                         width: "100%",
//                         borderCollapse: "collapse",
//                         fontSize: "11px",
//                     }}
//                 >
//                     <thead>
//                         <tr>
//                             <th style={thStyle}></th>
//                             {labels.map((l) => (
//                                 <th key={l} style={thStyle}>{l}</th>
//                             ))}
//                         </tr>
//                     </thead>

//                     <tbody>
//                         {chartData.datasets.map((ds) => (
//                             <tr key={ds.label}>
//                                 <td style={tdLabelStyle}><b>{ds.label}</b></td>
//                                 {ds.data.map((v, i) => (
//                                     <td key={i} style={tdValueStyle}>{v}</td>
//                                 ))}
//                             </tr>
//                         ))}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };

const OverallTransitionSummaryCharts = ({ labels, chartData }) => {
    // debugger
    const maxValue = Math.max(
        ...chartData.datasets.flatMap(ds => ds.data),
        0
    );

    // Calculate appropriate max value for better label visibility
    const chartMax = maxValue + Math.max(maxValue * 0.3, 20);

    const options = {
        responsive: true,
        maintainAspectRatio: false, // Add this to control height independently
        plugins: {
            legend: {
                position: "top",
                labels: {
                    usePointStyle: true,
                    pointStyle: "circle",
                    boxWidth: 12,
                    boxHeight: 12,
                    padding: 14,
                    font: { size: 12 },
                },
            },
            datalabels: {
                display: true,
                color: "#000",
                anchor: "center",
                align: (context) => {
                    // For bar charts, align based on value
                    const value = context.dataset.data[context.dataIndex];
                    return value > 0 ? 'top' : 'bottom';
                },
                offset: (context) => {
                    const chart = context.chart;
                    const datasetIndex = context.datasetIndex;
                    const value = context.dataset.data[context.dataIndex];
                    
                    if (value === 0) return -10; // Offset below for zero values
                    
                    // Calculate dynamic offset based on dataset position
                    // This spreads labels vertically for each dataset
                    const totalDatasets = chart.data.datasets.length;
                    const baseOffset = 8;
                    
                    // Center the labels around the bar
                    // For odd number of datasets: 0, ±15, ±30, etc.
                    // For even number of datasets: ±7.5, ±22.5, etc.
                    const middleIndex = (totalDatasets - 1) / 2;
                    const offsetFromMiddle = datasetIndex - middleIndex;
                    
                    return baseOffset + (offsetFromMiddle * 15);
                },
                font: {
                    size: 11, // Slightly smaller for better fit
                    weight: "bold",
                },
                formatter: (value) => (value > 0 ? value : ""),
                // Add background for better readability
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                borderRadius: 3,
                padding: 2,
            },
        },
        scales: {
            x: {
                // Adjust bar grouping for better spacing
                barPercentage: chartData.datasets.length > 2 ? 0.6 : 0.8,
                categoryPercentage: chartData.datasets.length > 2 ? 0.7 : 0.8,
                grid: {
                    display: false,
                },
            },
            y: {
                title: {
                    display: true,
                    text: "FTE Counts",
                },
                beginAtZero: true,
                max: chartMax,
                ticks: {
                    stepSize: Math.ceil(chartMax / 5 / 10) * 10, // Auto-calculate step size
                    callback: function(value) {
                        return Number.isInteger(value) ? value : '';
                    }
                },
                grid: {
                    drawBorder: false,
                },
            },
        },
        // Add more space on top for labels
        layout: {
            padding: {
                top: 30,
                bottom: 10,
            }
        }
    };

    const thStyle = {
        border: "1px solid #d2d2d2ff",
        padding: "4px",
        textAlign: "center",
        width: "100px",
        fontWeight: "bold",
        color: "#272323ff",
        background: "#f5f5f5",
    };

    const tdLabelStyle = {
        border: "1px solid #ddd",
        padding: "4px",
        textAlign: "center",
        width: "90px",
    };

    const tdValueStyle = {
        border: "1px solid #ddd",
        padding: "4px",
        textAlign: "center",
        width: "170px",
    };

    return (
        <div style={{ 
            width: "100%", 
            background: "#fff", 
            padding: "16px",
            position: "relative",
        }}>
            <div style={{ height: "400px", position: "relative" }}>
                <Bar data={chartData} options={options} />
            </div>
            <div style={{ marginTop: "16px", overflowX: "auto" }}>
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "11px",
                        marginTop: "20px",
                    }}
                >
                    <thead>
                        <tr>
                            <th style={thStyle}></th>
                            {labels.map((l) => (
                                <th key={l} style={thStyle}>{l}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {chartData.datasets.map((ds) => (
                            <tr key={ds.label}>
                                <td style={tdLabelStyle}><b>{ds.label}</b></td>
                                {ds.data.map((v, i) => (
                                    <td key={i} style={tdValueStyle}>{v}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};



export default OverallTransitionSummaryCharts;

// #################################################################################

// /* eslint-disable */
// import React from "react";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   PointElement,
//   LineElement,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { Bar } from "react-chartjs-2";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   PointElement,
//   LineElement,
//   Tooltip,
//   Legend
// );

// const OverallTransitionSummaryCharts = ({ title, tableHeaders, tableData }) => {

//   const chartData = {
//     labels: tableHeaders,
//     datasets: [
//       {
//         label: "Q1",
//         data: tableData.Q1,
//         backgroundColor: "#7CB342",
//       },
//       {
//         label: "Q2",
//         data: tableData.Q2,
//         backgroundColor: "#AED581",
//       },
//       {
//         label: "Q3",
//         data: tableData.Q3,
//         backgroundColor: "#C5E1A5",
//       },
//       {
//         label: "Q4",
//         data: tableData.Q4,
//         backgroundColor: "#FBC02D",
//       },
//       {
//         label: "Overall",
//         data: tableData.Overall,
//         type: "line",
//         borderColor: "#1E88E5",
//         backgroundColor: "#1E88E5",
//         tension: 0.3,
//         pointRadius: 5,
//         yAxisID: "y",
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: "bottom",
//       },
//       title: {
//         display: true,
//         text: title,
//         font: { size: 18 },
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         title: {
//           display: true,
//           text: "FTE Counts",
//         },
//       },
//     },
//   };

//   return (
//     <div style={{ width: "100%", margin: "0 auto" }}>
//       <Bar data={chartData} options={options} />
//       <table style={{ width: "100%", marginTop: "20px", borderCollapse: "collapse" }}>
//         <thead>
//           <tr>
//             <th>Quarter</th>
//             {tableHeaders.map((h) => (
//               <th key={h}>{h}</th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {Object.keys(tableData).map((key) => (
//             <tr key={key}>
//               <td>{key}</td>
//               {tableData[key].map((val, idx) => (
//                 <td key={idx}>{val}</td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default OverallTransitionSummaryCharts;
